import { Component, OnInit } from '@angular/core';
import {AzureBlobStorageService} from '../../services/blob/azure-blob-storage.service';
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss']
})
export class UploadDialogComponent implements OnInit {
  uploadProgress: number = 0;

  constructor(private azureBlobService: AzureBlobStorageService,
              private dialogRef: MatDialogRef<UploadDialogComponent>) { }

  ngOnInit(): void {
    this.azureBlobService.uploadProgress.subscribe((prog) => {
      this.uploadProgress = prog.progress;
      if (prog.progress === 100) {
        this.dialogRef.close();
      }
    });
  }

  onCancelClick() {
    this.azureBlobService.cancelUpload();
    this.dialogRef.close();
  }
}
